import { jwtDecode } from "jwt-decode";
import TokenService from "shared/api/token-service";
// Бэкенд кладёт в access-токен поле `role` (User.roles). В схеме это одиночный
// enum (строка), но guard на бэке принимает и массив — нормализуем к массиву.
var normalize = function (role) {
    return Array.isArray(role) ? role : role ? [role] : [];
};
// Роли из валидного (не протухшего) access-токена. [] если токена нет/протух.
export var getTokenRoles = function (token) {
    var raw = token !== null && token !== void 0 ? token : TokenService.getAccessToken();
    if (!raw)
        return [];
    try {
        var decoded = jwtDecode(raw.replace(/^Bearer\s+/i, ""));
        var now = Math.floor(Date.now() / 1000);
        if (!decoded.exp || decoded.exp <= now)
            return [];
        return normalize(decoded.role);
    }
    catch (_a) {
        return [];
    }
};
// SUPER_ADMIN включает права ADMIN — оба пускаются в админку.
export var ADMIN_ROLES = ["ADMIN", "SUPER_ADMIN"];
export var tokenHasAdminRole = function (token) {
    return getTokenRoles(token).some(function (r) { return ADMIN_ROLES.includes(r); });
};
export var isSuperAdmin = function (token) {
    return getTokenRoles(token).includes("SUPER_ADMIN");
};
